import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import imageIcon from '../file-alt.svg';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

export default class CoursabiContentLink extends Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('coursabiContentLink', locale => {

            const view = new ButtonView(locale);

            view.set({
                label: 'Insert Coursabi Content Link',
                icon: imageIcon,
                tooltip: true
            });

            // Callback executed once the button is clicked.

            view.on('execute', async () => {

				console.log('LoremIpsum clicked');

				const elementId = editor.config.get( 'elementId' );

				if (elementId) {

                    const selection = editor.model.document.selection;
                    const range = selection.getFirstRange();
                    var selectedText = '';

                    for (const item of range.getItems()) {
                        selectedText += item.data;
                    }  

					var text = await JsHelpersDict[elementId].dotnet.invokeMethodAsync('OpenAddLink', selectedText);
				}
            });

            return view;
        });        
    }
}
